// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_container {
  /* width: 25%; */
  background-color: #fafafa;
}

.sidebar-buttons-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dividing_line {
  margin-bottom: 20px;
  width: 80%;
  height: 2px;
  background-color: #f0f0f0;
}

@media screen and (max-width: 1050px) {
  .sidebar_container {
    display: none;
  }
}

@media screen and (max-width: 786px) {
}

@media screen and (max-width: 480px) {
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".sidebar_container {\n  /* width: 25%; */\n  background-color: #fafafa;\n}\n\n.sidebar-buttons-block {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.dividing_line {\n  margin-bottom: 20px;\n  width: 80%;\n  height: 2px;\n  background-color: #f0f0f0;\n}\n\n@media screen and (max-width: 1050px) {\n  .sidebar_container {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 786px) {\n}\n\n@media screen and (max-width: 480px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
